import { Link } from "react-router-dom";
import React from "react"

const SchoolProfileList =()=> {
    return(
        <div>

		<aside class="right-side areas">			
        <div class="content-area dash-contentss">
              <div class="page-title-wrpr">
                <div class="page-title-left-column">
                    <i class="icon-library1"></i>
                    <h2 class="page-title">School Profile</h2>
                </div>
                <div class="page-rightside-action-column">
                    <Link to="/add_school_profile" data-toggle="tooltip" title="Add New Faculty" class="addbtnitem-link"><i class="icon-add"></i></Link>
                </div>
            </div>
            
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                 <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                <li class="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                <li class="breadcrumb-item active" aria-current="page">School Profile</li>
              </ol>
            </nav>
            <div class="faculty-list-wrpr list-wrpr">
                <div class="list faculty">
                <div class="row">
                        <div class="col-md-2">
                            <div class="update-date">
                                <span class="date-wrpr">1</span>
                                <span class="desig">Sl.No</span>
                            </div>
                        </div>
                        <div class="col-md-5">
                            <div class="update-date">
                                <Link to="/school_profile"  class="desig">Academe of the Oaks</Link>
                                <span class="date-wrpr">School Name</span>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="update-date">
                                <span class="desig">146 New Street Decatur, Georgia 30030 404.405.2173</span>
                                <span class="date-wrpr">Address</span>
                                
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="list-action-wrpr text-right">
                                <Link to="/edit_links" data-toggle="tooltip" title="Edit" class="edit icon-pencil3"></Link>
                                <a href="#" data-toggle="tooltip" title="Delete"   class="delete icon-close1"></a>
                            </div>
                        </div>
                    </div>  
                </div>
                <div class="list faculty">
                    <div class="row">
                        <div class="col-md-2">
                            <div class="update-date">
                                <span class="date-wrpr">1</span>
                                <span class="desig">Sl.No</span>
                            </div>
                        </div>
                        <div class="col-md-5">
                            <div class="update-date">
                                <Link to="/school_profile"  class="desig">Academe of the Oaks</Link>
                                <span class="date-wrpr">School Name</span>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="update-date">
                                <span class="desig">146 New Street Decatur, Georgia 30030 404.405.2173</span>
                                <span class="date-wrpr">Address</span>
                                
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="list-action-wrpr text-right">
                                <Link to="/edit_links" data-toggle="tooltip" title="Edit" class="edit icon-pencil3"></Link>
                                <a href="#" data-toggle="tooltip" title="Delete"   class="delete icon-close1"></a>
                            </div>
                        </div>
                    </div>   
                </div>
                <div class="list faculty">
                <div class="row">
                        <div class="col-md-2">
                            <div class="update-date">
                                <span class="date-wrpr">1</span>
                                <span class="desig">Sl.No</span>
                            </div>
                        </div>
                        <div class="col-md-5">
                            <div class="update-date">
                                <Link to="/school_profile"  class="desig">Academe of the Oaks</Link>
                                <span class="date-wrpr">School Name</span>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="update-date">
                                <span class="desig">146 New Street Decatur, Georgia 30030 404.405.2173</span>
                                <span class="date-wrpr">Address</span>
                                
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="list-action-wrpr text-right">
                                <Link to="/edit_links" data-toggle="tooltip" title="Edit" class="edit icon-pencil3"></Link>
                                <a href="#" data-toggle="tooltip" title="Delete"   class="delete icon-close1"></a>
                            </div>
                        </div>
                    </div> 
                </div>
  
                <div class="pagination-wrpr">
                    <ul class="pagination">
                      <li class="page-item"><a class="page-link" href="#"><i class="icon-navigate_before"></i></a></li>
                      <li class="page-item active"><a class="page-link" href="#">1</a></li>
                      <li class="page-item"><a class="page-link" href="#">2</a></li>
                      
                      <li class="page-item"><a class="page-link" href="#">3</a></li>
                      <li class="page-item"><a class="page-link" href="#"><i class="icon-navigate_next"></i></a></li>
                    </ul>
                </div>       
            </div>        
        </div>
        </aside>
    </div>
    );
}

export default SchoolProfileList